import React, { useState } from "react";
import { Button, Input } from "antd";
import { Helmet } from "react-helmet";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "../common/Navbar";
import { handleSignUpSubmit } from "../../services/LoginService";
import { BASE_IMG, BRAND_NAME, BRAND_TAGLINE, LOGIN_LOGO_IMG, LOGIN_TITLE_IMG } from "../../constants";
import { showErrorMessage, showLoader, showSuccessMessage } from "../../utils";
import "./style.css";

export default function ResetPasswordComponent() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState("password");
  const [isLoading, setIsLoading] = useState(false);

  const canSubmit = Boolean(email && password);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!canSubmit) {
      showErrorMessage("Enter all fields");
      return;
    }

    setIsLoading(true);
    const name = email.split("@")[0];
    const { success, message = "" } = await handleSignUpSubmit(name, email, password);
    if (success) {
      showSuccessMessage(message || "Password reset successful");
      navigate("/login");
    } else {
      showErrorMessage(message || "Could not reset password");
    }
    setIsLoading(false);
  };

  return (
    <>
      <Helmet>
        <title>{BRAND_NAME} - Reset Password</title>
        <meta
          name="description"
          content={`Set a new password for your ${BRAND_NAME} account.`}
        />
        <link rel="canonical" href="/reset" />
      </Helmet>

      <div>
        <div className="login">
          <div className="left-container">
            <img src={`${BASE_IMG}/login_left.svg`} height="95%" width="95%" alt="Illustration" />
          </div>
          <div className="right-container">
            <div className="right-subContainer reset-password-container">
              <div className="app-title-logo">
                <div className="app-logo">
                  <img src={LOGIN_LOGO_IMG} alt="Logo" height="100%" width="100%" />
                </div>
                {LOGIN_TITLE_IMG ? (
                  <div className="app-title">
                    <img src={LOGIN_TITLE_IMG} alt="Title" />
                  </div>
                ) : null}
              </div>
              <div className="app-motto-text">{BRAND_TAGLINE}</div>

              <div className="register-box-container">
                <div className="login-box-text">Reset password</div>
                <p className="login-bottom-text-container-middle">Set a new password for your account.</p>
                <form className="auth-form" onSubmit={handleSubmit}>
                  <div className="login-box-input-container">
                    <Input
                      className="login-box-input-container2"
                      type="email"
                      autoComplete="email"
                      value={email}
                      placeholder="Email"
                      onChange={(event) => setEmail(event.target.value)}
                    />
                    <Input
                      className="login-box-input-container2"
                      type={showPassword}
                      autoComplete="new-password"
                      value={password}
                      placeholder="New password"
                      onChange={(event) => setPassword(event.target.value)}
                      suffix={
                        showPassword === "password" ? (
                          <img
                            src={`${BASE_IMG}/eye.svg`}
                            alt="show-password"
                            className="password-icon"
                            onClick={() => setShowPassword("text")}
                          />
                        ) : (
                          <img
                            src={`${BASE_IMG}/cross_eye.svg`}
                            alt="hide-password"
                            className="password-icon"
                            onClick={() => setShowPassword("password")}
                          />
                        )
                      }
                    />
                  </div>
                  <div className="login-box-button-container">
                    <Button
                      className="login-box-button-container-button"
                      htmlType="submit"
                      disabled={!canSubmit}
                    >
                      <div className="login-box-button-container-button-text">Update password</div>
                    </Button>
                  </div>
                </form>
                <p className="login-bottom-text-container-middle"><Link to="/login">Back to login</Link></p>
              </div>
              <p className="login-bottom-text-container-bottom reset-password-copyright">
                &copy; Copyright 2026 RazeHQ. All rights reserved.
              </p>
            </div>
          </div>
        </div>
        <Navbar showSettings={false} />
        {isLoading && showLoader("Updating")}
      </div>
    </>
  );
}
